var React = require('react');

function Yt (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"d":"M14.82 7.502l1.74.002.715.008c8.617.128 10.122 1.373 10.22 7.74l.006.748-.006.757c-.104 6.611-1.73 7.693-11.28 7.741H14.82l-1.019-.012c-7.874-.142-9.234-1.461-9.298-7.962l-.002-.79.005-.534c.105-6.527 1.656-7.646 10.314-7.698zM14 13v6l5-3-5-3z","fill":"currentColor","fillRule":"nonzero","key":1})]));
}

Yt.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Yt;

Yt.default = Yt;
